enum EndorsementEntityType {
	POLICY = 'Policy',
	BUILDING = 'Building',
	MORTGAGEE = 'Mortgagee',
}

export default EndorsementEntityType;